module.exports = __webpack_public_path__ + "static/media/IMG_6106.dd4b1eb9.jpg";